module.exports = new __parcel__URL__("MetaPool_logo.49c6f9c0.png").toString();